module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0092.jpg?v=0ee01fe4";